import getWeekSize from './getWeekSize'
import { DAYS_IN_WEEK } from './weekLayoutConstants'

type Params = {
  item: {
    start: string
    end: string
  }
  timeRange: {
    start: string
    end: string
  }
}

export const computePercentWidth = ({ item, timeRange }: Params) => {
  const cellUnitSize = getWeekSize({ item, timeRange })

  const percent = (cellUnitSize / DAYS_IN_WEEK) * 100
  const percentWidthValue = `calc(${percent}% - 5px)`
  return percentWidthValue
}
